import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import loadCreditData from "@tSurya/Handlers/CreditMemoData";
import loadFinancialTransaction from "@tSurya/Handlers/SurFinancialTransactions";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import SuryaPageThemeWrapper from "@tSurya/Utils/SuryaPageThemeWrapper";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        pagination: state.SURData.financialTransactionStore.financialData?.pagination,
        serachedParameter: state.SURData.financialTransactionStore.searchparameter,
    };
};

const mapDispatchToProps = {
    loadFinancialTransaction,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const paginationStyles: PaginationStyles = {};

const styles = paginationStyles;

const SurFinancialTransactionPagination: FC<Props> = ({ loadFinancialTransaction, pagination, serachedParameter }) => {
    if (!pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions } = pagination;

    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        loadFinancialTransaction({
            ...serachedParameter,
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);

        loadFinancialTransaction({
            ...serachedParameter,
            pageSize: newPageSize,
        });
    };

    return (
        <SuryaPageThemeWrapper>
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie="SurFinancialTransactionData-PageSize"
        />
        </SuryaPageThemeWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SurFinancialTransactionPagination),
    definition: {
        displayName: "SurFinancialTransactionPagination",
        group: "Common",
    },
};

export default widgetModule;
